import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';

@Pipe({
  name: 'keepHtml'
})
export class KeepHtmlPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}
 
  public transform(value: any) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
